<template>
  <c-modal v-if="client" class="edit-client" :title="title" size="lg" :show="show" @update:show="toggle">
    <c-input v-model="data.body.name" label="Name" type="text" placeholder="Enter client name" />
    <c-input v-model="data.body.contactName" label="Contact name" type="text" placeholder="Enter contact name" />
    <c-input
      v-model="data.body.contactEmailAddress"
      label="Contact email address"
      type="text"
      placeholder="Enter email"
    />

    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" :disabled="isSaving" @click="save">Save</c-button>
        <c-button color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditClient',
  props: {
    show: Boolean,
    client: Object,
  },
  data() {
    return {
      isSaving: false,
      data: {
        body: {
          name: '',
          contactName: '',
          contactEmailAddress: '',
        },
      },
    };
  },
  computed: {
    title() {
      return `Edit ${this.client.name}`;
    },
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.data.body.name = this.client.name;
      this.data.body.contactName = this.client.contactName;
      this.data.body.contactEmailAddress = this.client.contactEmailAddress;
    },
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    close() {
      this.setData();
      this.$emit('close');
    },
    save() {
      this.isSaving = true;
      const data = {
        clientId: this.client._id,
        name: this.data.body.name,
        contactName: this.data.body.contactName,
        contactEmailAddress: this.data.body.contactEmailAddress,
      };

      this.$http
        .post(buildEndpoint('clients/update'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Client updated',
            });
            this.$emit('updated', data);
            this.close();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error saving client data',
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>
